// extracted by mini-css-extract-plugin
export var infoItem = "_s1-2";
export var title = "_s1-0";
export var value = "_s1-1";